'use client'

import type { PropsWithChildren } from 'react'
import { isMobile, isTablet } from 'react-device-detect'

import { AUTH_ERROR_URL, LOGIN_URL, REGISTER_URL, VERIFY_EMAIL_URL } from '~/core/constants/url'

import { useRouterContext } from '~/lib/next/use-router-context'

import MobileNotSupportView from './MobileNotSupportView'

const ALLOWED_MOBILE_PATH_REGEXS = [
  `^${LOGIN_URL}*`,
  `^${REGISTER_URL}$`,
  `^${AUTH_ERROR_URL}$`,
  `^${VERIFY_EMAIL_URL}$`,
  '^/careers/(.*)$',
  '/requisitions/((?!(create|edit)).)*$'
]

const NoSupportMobileDetectView = ({ children }: PropsWithChildren) => {
  const { asPath } = useRouterContext()

  return (
    <>
      {!isMobile ||
      isTablet ||
      !!ALLOWED_MOBILE_PATH_REGEXS.find((path) => asPath.match(new RegExp(path))) ? (
        children
      ) : (
        <MobileNotSupportView />
      )}
    </>
  )
}

export default NoSupportMobileDetectView
